// extracted by mini-css-extract-plugin
export default {"MainCont":"MakeUp_MainCont__nMnkI","LeftCont":"MakeUp_LeftCont__BvHas","RightCont":"MakeUp_RightCont__NFXaT"};